<template>
  <b-modal
    v-model="showModal"
    title-class="h3 text-white"
    size="lg"
    centered
    :title="$t('Notifications')"
    hide-footer
    modal-class="modal-primary"
    @hidden="closeNotifications"
  >
    <b-list-group>
      <template v-if="!loading">
        <b-list-group-item
          v-for="notification in notifications"
          :key="notification.id"
          @click="
            notification.status == 1
              ? null
              : clickReadNotification(notification)
          "
        >
          <div class="d-flex w-100 justify-content-between">
            <b-media no-body>
              <b-media-aside class="mr-2 mt-50">
                <b-avatar
                  :class="notification.status == 1 ? '' : 'cursor-pointer'"
                  size="50"
                  :src="notification.image"
                  :variant="
                    notification.status == 1
                      ? 'light-secondary'
                      : 'light-primary'
                  "
                >
                </b-avatar>
              </b-media-aside>
              <b-media-body>
                <div
                  :class="[
                    'font-weight-bold mb-0 h5 clickable',
                    notification.status == 0
                      ? skin == 'dark'
                        ? 'text-light'
                        : 'text-dark'
                      : '',
                  ]"
                  class="d-flex"
                >
                  <p class="notification-title text-secondary">{{ $t(notification.title) }}</p>
                </div>
                <p class="text-muted">{{ $t(notification.subtitle) }}</p>
              </b-media-body>
            </b-media>
            <small>{{ notification.created_at | myDateGlobal }}</small>
          </div>
        </b-list-group-item>
      </template>

      <template v-else>
        <b-list-group-item
          v-for="notification in notifications.length"
          :key="notification.id"
        >
          <div class="d-flex w-100 justify-content-between align-items-center">
            <b-media no-body class="w-100">
              <b-media-aside class="mr-2" width="100%">
                <b-skeleton type="avatar" size="30px" />
              </b-media-aside>
              <b-media-body class="my-auto">
                <b-skeleton style="margin-top: 9px" />
              </b-media-body>
            </b-media>
            <small />
          </div>
        </b-list-group-item>
      </template>
    </b-list-group>
    <!-- Pagination -->
    <div class="mx-2 mb-2 mt-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted"
            >Showing {{ startPage }} to {{ toPage }} of
            {{ totalData }} entries</span
          >
        </b-col>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalData"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import GeneralService from "@/views/services/general.service.js";

export default {
  async mounted() {
    await this.getAllNotifications();
  },
  data() {
    return {
      currentPage: 1,
      perPage: 7,
      totalData: 0,
      startPage: 0,
      toPage: 0,
      loading: false,
      selectedNotification: {},
      showModal: true,
      notifications: [],
    };
  },
  async mounted() {
    await this.getAllNotifications();
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      skin: "appConfig/skin",
      G_NOTIFICATION_COUNTER: "NotificationStore/G_NOTIFICATION_COUNTER",
    }),
  },
  methods: {
    // ...mapActions({
    //   A_GET_ALL_USER_NOTIFICATIONS:
    //     'NotificationStore/A_GET_ALL_USER_NOTIFICATIONS',
    //   A_UPDATE_NOTIFICATION: 'NotificationStore/A_UPDATE_NOTIFICATION',
    // }),
    // ...mapMutations({
    //   DECREASE_NOTIFICATION_COUNTER:
    //     "NotificationStore/DECREASE_NOTIFICATION_COUNTER",
    //   DECREASE_ALL_NOTIFICATION_COUNTER:
    //     "NotificationStore/DECREASE_ALL_NOTIFICATION_COUNTER",

    // }),
    async getAllNotifications(page = 1) {
      this.loading = true;
      try {
        const { data } = await GeneralService.getAllNotifications({
          user_id: this.currentUser.employee_id,
          page,
        });
        this.notifications = data.data;
        this.currentPage = data.current_page;
        this.perPage = data.per_page;
        this.totalData = data.total;
        this.startPage = data.from;
        this.toPage = data.to;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    async clickReadNotification(notification) {
      //   const { data } = await NotificationService.readNotificationById({
      //     id: notification.id,
      //   });
      //   notification.status = 1;
      //   if (this.G_NOTIFICATION_COUNTER > 0) {
      //     this.DECREASE_NOTIFICATION_COUNTER();
      //   }
    },
    closeNotifications() {
      this.$emit("close");
    },
    // async clickReadAllNotifications() {
    //   this.addPreloader();
    //   try {
    //     await NotificationService.readAllNotificationsByIdUser({
    //       id: this.currentUser.user_id,
    //     });
    //     this.DECREASE_ALL_NOTIFICATION_COUNTER();
    //     this.getAllNotifications();
    //     this.showToast(
    //       "success",
    //       "top-right",
    //       "Success",
    //       "CheckIcon",
    //       "All notifications marked as read"
    //     );
    //     this.$emit("readAllNotificationsByUser");
    //   } catch (error) {
    //     this.showErrorSwal(error);
    //   } finally {
    //     this.removePreloader();
    //   }
    // },
  },
  watch: {
    currentPage(newVal, oldVal) {
      this.getAllNotifications(newVal);
    },
  },
};
</script>

<style>
/* .list-group-item-selected {
  background-color: #82868b !important;
  border-color: white !important;
  color: white !important;
  opacity: 0.6 !important;
} */
/* .list-group-item-selected h5,
h4 {
  color: white !important;
} */

.read-all-notification-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.mt-50 {
  margin-top: 0.5rem !important;
}

.notification-title {
  font-size: 14px;
  font-weight: 600;
}
</style>
